import {NdmsResolverService} from "../../../../../../shared/core/interfaces/ndmsResolverService";
import {EventEmitter, Injectable} from '@angular/core';
import {ViewModelModelMappingService} from "../../../../../../shared/core/services/view-model-model-mapping.service";
import {LookupService} from "../../../../../../shared/core/services/lookup.service";
import {ToastService} from "../../../../../../shared/core/services/toast.service";
import {ViewModelService} from "../../../../../../shared/core/services/view-model.service";
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {PatientViewModel} from "../../../../shared/ui-jpats/view-models/patient.view-model";
import {PatientIdentifierViewModel} from "../../../../shared/ui-jpats/view-models/patient-identifier.view-model";
import SaveIdentifierParams = PatientService.SaveIdentifierParams;
import {PatientMedicalDetailsViewModel} from "../../../../shared/ui-jpats/view-models/patient-medical-details.view-model";
import SavePatientMedicalDetailsParams = PatientService.SavePatientMedicalDetailsParams;
import {PatientService} from "../../../../api/services/patient.service";
import {PatientModel} from "../../../../api/models/patient-model";
import {PatientDetailsModel} from "../../../../api/models/patient-details-model";
import {PatientModelEditorViewModel} from "../../../../api/models/patient-model-editor-view-model";
import {PatientListModelQueryResponseViewModel} from "../../../../api/models/patient-list-model-query-response-view-model";
import * as moment from 'moment';
import {PatientQueryModel} from "../../../../api/models/patient-query-model";
import {catchError, map} from "rxjs/operators";

@Injectable()
export class PatientRegistrationService extends NdmsResolverService {
  newPatient = new EventEmitter<any>();
  patientCreated = new EventEmitter<any>();
  patientSaved = new EventEmitter<any>();
  stepTwo = new EventEmitter<any>();
  patientMedicalDetailsSaved = new EventEmitter<any>();
  continueNewPatient = new EventEmitter<any>();
  savePatientInfo = new EventEmitter<PatientViewModel>();
  currentPatient: PatientViewModel;
  fullPatientDetails: PatientDetailsModel;
  currentPatientKey?: string = undefined;
  currentIdentifierNumber?:string = undefined;
  constructor(private apiService: PatientService,
              private lookupService: LookupService,
              private router: Router,
              private toastService: ToastService,
              private viewModelService: ViewModelService,
              private viewModelModelMappingService: ViewModelModelMappingService) {
    super();
    this.savePatientInfo.subscribe((data:PatientViewModel)=>{
      this.savePatientGeneralInfo(data);
    });
  }

  get(key: string) {
    return this.apiService.GetByKey(key).pipe(map(
      (editorVm: PatientModelEditorViewModel) => {
        let responderViewModel = this.viewModelModelMappingService.fromApiModel<PatientModel, PatientViewModel>(
          new PatientViewModel(),
          editorVm.model);
        this.viewModelService.loadViewModelData(PatientViewModel.name, responderViewModel);
        return responderViewModel;
      }
    ),catchError(error => {
      if (error instanceof HttpErrorResponse && !error.ok) {
        this.toastService.showError(error.name + ' Error.');
      }
      this.router.navigate(['/patients']);
      return new Observable();
    }));
  }

  savePatientGeneralInfo(patientViewModel: PatientViewModel) {
    this.currentPatient = patientViewModel;
    this.emitPatientCreated(this.currentPatient);
  }

  savePatientDetails(patientMedicalDetailsViewModel: PatientMedicalDetailsViewModel) {

    let patientDetails: PatientDetailsModel = Object.assign({}, this.currentPatient , {
      name: {firstName: this.currentPatient.firstName, lastName: this.currentPatient.lastName}
    });
    patientDetails.patientMedicalDetailsModel = {
      patientBedType: patientMedicalDetailsViewModel.patientBedType,
      injuryNatureDescription: patientMedicalDetailsViewModel.injuryNatureDescription,
      notes: patientMedicalDetailsViewModel.notes,
      patientHealthStatus: patientMedicalDetailsViewModel.patientHealthStatus,
      patientType: patientMedicalDetailsViewModel.patientType
    };
    patientDetails.patientIdentifierModel = {
      identifierNumber: this.currentPatient.identifierNumber,
      identifierType: this.currentPatient.identifierType
    };
    this.fullPatientDetails =patientDetails;
    this.emitPatientMedicalDetailsSaved(this.fullPatientDetails);
    return new Observable<any>((observer)=> {
      observer.next(this.fullPatientDetails);
    });
  }
  commitChanges(){
    return this.apiService.Save(this.fullPatientDetails).pipe(map((apiViewModel: PatientModelEditorViewModel) => {
      let patientsSaveResponse: any = this.viewModelModelMappingService.fromApiModel(new PatientViewModel(), apiViewModel.model);
      this.currentPatientKey = apiViewModel.model!.key;
      this.currentIdentifierNumber = undefined;
      return patientsSaveResponse.toFormGroup();
    }));
  }
  searchPatientsByInfo(patientViewModel: PatientViewModel) {

    let queryParams: PatientQueryModel = {
      firstName: patientViewModel.firstName,
      lastName: patientViewModel.lastName,
      gender: patientViewModel.gender,
      age: patientViewModel.age,
      ageQualifier: patientViewModel.ageQualifier,
      birthDate: (patientViewModel.birthDate ? moment(patientViewModel.birthDate).format("MM/DD/YYYY") : undefined),
      page: 0
    };
    return this.apiService.Query(queryParams).pipe(map((searchResult: PatientListModelQueryResponseViewModel) => {
      return searchResult;
    }));
  }

  searchPatientsByBarcode(patientIdentifierViewModel: PatientIdentifierViewModel) {
    if(patientIdentifierViewModel.identifierNumber){
      let queryParams: PatientQueryModel= {
        identityNumber: patientIdentifierViewModel.identifierNumber,
        page: 0
      };
      return this.apiService.Query(queryParams).pipe(map((searchResult: PatientListModelQueryResponseViewModel) => {
        return searchResult;
      }))
    }else{
      return new Observable<any>((observer)=> {
        observer.next({model:[]});
      });
    }

  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.apiService.GetByKey("").pipe();
  }

  emitStepTwo(newPatientData) {
    this.stepTwo.emit(newPatientData);
  }

  emitPatientCreated(patientCreatedData) {
    this.patientCreated.emit(patientCreatedData);
  }

  emitNewPatient(newPatientData) {
    this.newPatient.emit(newPatientData);
  }

  emitPatientSaved(patientSavedData) {
    this.patientSaved.emit(patientSavedData);
  }

  emitPatientMedicalDetailsSaved(detailsSavedResponse) {
    this.patientMedicalDetailsSaved.emit(detailsSavedResponse);
  }

  selectPatient(patientModel: PatientModel) {

  }
  emitSavePatientGeneralInfo(data: PatientViewModel){
    this.savePatientInfo.emit(data);
  }
  emitContinueNewPatient(data: any) {
    this.continueNewPatient.emit(data);
  }
}
